<template lang="pug">
Page(titleType="custom")
  template(slot="header-title")
    .header-title-left
      span {{ $t('Integrations.pageHeader_Franchise') }}
  template(slot="content-center")
    EmptyState(
      v-if="!franchiseList.length"
      iconName="empty-state-franchise"
      :title="$t('Integration.emptyState_Franchise_NotFound_Title')"
      :description="$t('Integration.emptyState_NotFound_Franchise_Description_Order')")

    .franchise-table(v-else)
      .head
        .row
          .col.u-textCenter.franchise {{ $t('Integration.isFranchise') }}
          .col.storeGroup {{ $t('Dictionary.StoreGroup') }}
          .col.u-textRight {{ $t('Integration.budget') }}
          .col.u-textCenter.can-exceed-limit {{ $t('Integration.canExceedLimit') }}
          .col.u-textRight {{ $t('Integration.limitPercentage') }}
          .col
      
      .body
        .row(v-for="(row, index) in franchiseList" :key="row.id" :id="`table-body-row-franchise-list-${index}`")
          .col.u-textCenter.franchise
            SwitchButton.switch-button( 
              :active="row.isFranchise"
              id="btn-dashboard-switch-status"
              @change="toggleFranchise(row)")

          .col.storeGroup {{ row.storeGroupName }}

          .col.u-textRight(:id="`from-store-name-requested-transfer-${index}`")
            .currency-input
              currency-input.txt(
                :name="`franchiseBudget-${row.index}-${row.storeGroupId}`"
                id="franchise-budget"
                :disabled="!row.isFranchise"
                v-validate="'greater_than:0'"
                :data-vv-as="$t('Integration.franchiseBudget')"
                :error="veeErrors.has(`franchiseBudget-${row.index}-${row.storeGroupId}`)"
                :class="{ 'is-danger':veeErrors.has(`franchiseBudget-${row.index}-${row.storeGroupId}`) }"
                v-model="row.budget"
              )
              .currency-input-symbol(:class="!row.isFranchise ? 'passive-currency-symbol' : ''")  {{ '₺' }}

          .col.u-textCenter.can-exceed-limit(:id="`store-name-requested-transfer-${index}`")
            CustomCheckbox( 
              label=""
              :checked="row.canExceedLimit"
              :disabled="!row.isFranchise"
              id="btn-can-exceed-limit-checkbox"
              @change="changeExceedCondition(row)")

          .col.u-textRight(:id="`limit-percentage-franchise-${index}`")
            .control
              customNumberInput(
                :name="`limitPercentage-${row.index}-${row.storeGroupId}`"
                id="franchise-limit-percentage"
                :isTypePercentage="true"
                v-validate="'numeric|min_value:0'"
                :data-vv-as="$t('Integration.limitPercentage')"
                :error="veeErrors.has(`limitPercentage-${row.index}-${row.storeGroupId}`)"
                :disabled="!row.isFranchise || !row.canExceedLimit"
                v-model="row.limitPercentage"
              )
          
          .col
            Button.m-left-10(
              primary
              size="small"
              tabindex="-1",
              :id="`button-integration-submit`"
              variant="icon",
              iconName="icon-btn-success",
              @click="saveFranchise(row, index)"
              :justIcon="true"
              iconClass="icon-btn-success"
            )

        
</template>

<script>

import SwitchButton from '@/view/global/switch-button'

import { mapActions } from 'vuex'


export default {
  name: 'StoreGroupFranchise',

  components: {
    SwitchButton
  },

  data () {
    return {
      franchiseList: null,
      renderComponent: true
    }
  },

  async created () {
    await this.getStoreGroupFranchiseList().then(res => {
      this.franchiseList = res.data.franchiseStoreGroupList
    })
  },

  methods: {
    ...mapActions('Franchise', ['getStoreGroupFranchiseList', 'setStoreGroupFranchiseConfig']),
    ...mapActions('Notify', ['notifyShow']),

    async saveFranchise (item) {
      await this.$validator.validateAll().then(async result => {
        if (!result) return
        const payload = {
          storeGroupId: item.storeGroupId,
          isFranchise: item.isFranchise,
          budget: item.budget,
          canExceedLimit: item.canExceedLimit,
          limitPercentage: item.limitPercentage
        }
        this.setStoreGroupFranchiseConfig(payload).then(res => {
          if (res) {
            const message = this.$t('Integration.success_Set_Franchise')
            this.notifyShow({ message })
            this.getStoreGroupFranchiseList()
          }
        })
      })
    },

    toggleFranchise (row) {
      row.isFranchise = !row.isFranchise
    },

    changeExceedCondition (row) {
      row.canExceedLimit = !row.canExceedLimit
      if (!row.canExceedLimit) row.limitPercentage = null
    }
  }
}
</script>


<style lang="scss" scoped>

  .franchise-table {
    height: 70vh;
    overflow-y: scroll;
    .row {
      display: flex;
      align-items: center;
      border-radius: $border-radius;
      border: 1px solid $color-gray;
    }
    .col {
      min-width: 100px;
      display: flex;
      align-items: center;
      width: 200px;
      font-size: $font-size-small;
    }
    .head {
      font-size: $font-size-micro;
      font-weight: $font-weight-bold;
      color: $color-success;
      z-index: 400;
      position: sticky;
      top: 0;

      .row {
        background-color: $color-lighter-blue;
      }
      .col {
        padding: 20px 15px;
      }
      .col.unitCount {
        flex: 2;
      }
    }
    .body {
      .row {
        font-size: $font-size-small;
        background: $color-snow;
        &:nth-child(odd) {
          background-color: $color-white;
        }
      }

      .col {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-right: 1px solid #eaeaeb;
        padding: 10px 15px;
        height: 54px;
        &:last-child {
          border-right: none !important;
        }
      }
    }
  }
  .integration-sales-forecasting-content {
    margin-top: 10%;
    display: flex;
    align-content: center;
    flex-direction: column;
    align-items: center;
    &-title {
      font-size: $font-size-bigger;
      margin-top: 30px;
      font-weight: 420;
      color: #191818;
    }
    &-description {
      color: #91979C;
      font-weight: 420;
      font-size: $font-size-normal;
    }
    &-phone {
      font-weight: 450;
      margin-top: 40px;
      font-size: $font-size-bigger;
      display: flex;
      align-items: center;
    }
  }
  .storeGroup {
    width: fit-content !important;
    min-width: 400px !important;
  }

  .currency-input {
    position: relative;
    text-align: right;
    .txt {
      text-align: right !important;
    }
    &-symbol {
      position: absolute;
      left: 10px;
      top: 10px;
      color: #393939;
    }
  }
  .franchise {
    width: fit-content !important;
  }
  .can-exceed-limit {
    width: fit-content !important;
    min-width: 120px !important;
    max-width: fit-content !important;
    display: flex !important;
    justify-content: center !important;
  } 
  .passive-currency-symbol {
    color: #39393988;
  }
</style>
